import { createMeeting, fetchMeetingsByTimeRange, updateMeeting, deleteMeeting, fetchSchools, fetchClasses, fetchClassesBySchool, fetchTeachers, fetchSchoolsPaginated, fetchClassesBySchoolPaginated } from "@store/actions/calendarActions"
import { AppState, AppDispatch } from '../store';
import { useDispatch, useSelector } from "react-redux";
import { setSearchFilter,setMeetingListFilters } from "@store/reducers/calendarReducer";
interface meetingListFilters{
  class_id: number|null
}
export const useCalendar = () => {
  const dispatch: AppDispatch = useDispatch();
  const meetingList = useSelector((state: AppState) => state.calendar.meetingList);
  const schools = useSelector((state: AppState) => state.calendar.schools);
  const classes = useSelector((state: AppState) => state.calendar.classes);
  const classesBySchool = useSelector((state: AppState) => state.calendar.classesBySchool);
  const teachers = useSelector((state: AppState) => state.calendar.teachers);
  const searchFilter = useSelector((state: AppState) => state.calendar.searchFilter);
  const meetingListFilters = useSelector((state: AppState) => state.calendar.meetingListFilters)
  const loadingAction = useSelector((state: AppState)=> state.calendar.loadingAction)
  const schoolsPaginated = useSelector((state: AppState) => state.calendar.schoolsPaginated);
  const classesBySchoolPaginated = useSelector((state: AppState) => state.calendar.classesBySchoolPaginated);
  
  const fetchMeetingsByTimeRangeAction = (filters: any) => {
    dispatch(fetchMeetingsByTimeRange(filters))
  }

  const createMeetingAction = (filters: any) => {
    dispatch(createMeeting(filters))
  }

  const updateMeetingAction = (id: string, data: any) => {
    dispatch(updateMeeting(id, data))
  }

  const deleteMeetingAction = (id: string, start_time:string, class_id?: any) => {
    dispatch(deleteMeeting(id,start_time, class_id))
  }

  const fetchSchoolsAction = () => {
    dispatch(fetchSchools())
  }

  const fetchClassesAction = () => {
    dispatch(fetchClasses())
  }

  const fetchClassesBySchoolAction = (schoolId: number) => {
    dispatch(fetchClassesBySchool(schoolId))
  }

  const fetchTeachersAction = (schoolId: number, classId: number,type?:string|null, page?:number | null, pageSize?:number | null) => {
    dispatch(fetchTeachers(schoolId, classId,type, page, pageSize))
  }

  const updateSearchFilter = (option: number | null, value: string) => {
    dispatch(setSearchFilter({ option, value }));
  }
  const updateMeetingListFiltersCalendar = (filters: meetingListFilters) => {
      dispatch(setMeetingListFilters(filters))
  }

  const fetchSchoolsPaginatedAction = (params: { page: number; page_size: number; search?: string }) => {
    dispatch(fetchSchoolsPaginated(params));
  }

  const fetchClassesBySchoolPaginatedAction = (params: { schoolId: number; page: number; page_size: number; search?: string }) => {
    dispatch(fetchClassesBySchoolPaginated(params));
  }

  return {
    fetchMeetingsByTimeRangeAction,
    createMeetingAction,
    updateMeetingAction,
    deleteMeetingAction,
    fetchSchoolsAction,
    fetchClassesAction,
    fetchClassesBySchoolAction,
    fetchTeachersAction,
    updateSearchFilter,
    meetingList,
    schools,
    classes,
    classesBySchool,
    teachers,
    searchFilter,
    updateMeetingListFiltersCalendar,
    meetingListFilters,
    loadingAction,
    schoolsPaginated,
    classesBySchoolPaginated,
    fetchSchoolsPaginatedAction,
    fetchClassesBySchoolPaginatedAction,
  }
}